var watchPropertyDescriptor = Object.getOwnPropertyDescriptor(Object.prototype, "watch");
if (watchPropertyDescriptor != null) {
    var clone = {};

    Object.keys(watchPropertyDescriptor).forEach(function(prop) {
       clone[prop] = watchPropertyDescriptor[prop];
    });

    clone.writable = true;
    Object.defineProperty(Object.prototype, "watch", clone);
}